import React, { useCallback, useEffect, useState } from 'react';
import { Form } from '@unform/web';
import { Button, Grid, Link } from '@material-ui/core';
import Axios from 'axios';

import Input from '../../../../../../components/InputLogged';
import Select from '../../../../../../components/SelectLogged';

import api from '../../../../../../services/api';

import * as S from './styles';
import { ButtonStyled } from '../../styles';
import { useToast } from '../../../../../../hooks/toast';
import { useAuth } from '../../../../../../hooks/auth';

const IFood: React.FC = () => {
  const { addToast } = useToast();
  const { user } = useAuth();

  const [merchants, setMerchants] = useState<string[][]>([]);
  const [merchantId, setMerchantId] = useState<string>();
  const [credentialId, setCredentialId] = useState<number>();
  const [authorizationCodeVerifier, setAuthorizationCodeVerifier] = useState<
    string
  >();
  const [userCodeLink, setUserCodeLink] = useState<string>();

  const getUserCodeLink = useCallback(async () => {
    try {
      const ifoodCredentialsResponse = await api.get(
        `/companies/${user.empresa_id}/integrations`,
      );

      const ifoodCredentials = ifoodCredentialsResponse.data.find(
        (integration: any) => integration.type === 1,
      );

      setMerchantId(ifoodCredentials?.key ?? undefined);
      setCredentialId(ifoodCredentials?.id ?? undefined);

      if (!ifoodCredentials) {
        const userCodeResponse = await api.post(
          `/companies/${user.empresa_id}/ifood/userCode`,
        );

        setAuthorizationCodeVerifier(
          userCodeResponse.data.authorizationCodeVerifier,
        );
        setUserCodeLink(userCodeResponse.data.verificationUrlComplete);
      }
    } catch (err) {
      addToast({
        title: 'Erro ao gerar código',
      });
    }
  }, [user.empresa_id, addToast]);

  useEffect(() => {
    getUserCodeLink();
  }, [getUserCodeLink]);

  const handleSubmit = useCallback(
    async ({ code }) => {
      try {
        const tokenResponse = await api.post(
          `/companies/${user.empresa_id}/ifood/token`,
          {
            authorizationCode: code,
            authorizationCodeVerifier,
          },
        );

        if (tokenResponse.data.integrationId) {
          setCredentialId(tokenResponse.data.integrationId);
          setUserCodeLink(undefined);

          const marchantsResponse = await api.get(
            `/companies/${user.empresa_id}/ifood/merchants`,
          );

          setMerchants(
            marchantsResponse.data.map((merchant: any) => [
              merchant.name,
              merchant.id,
            ]),
          );
        }
      } catch (err) {
        addToast({
          title: 'Erro ao gerar código',
        });
      }
    },
    [user.empresa_id, authorizationCodeVerifier, addToast],
  );

  const handleFinish = useCallback(
    async ({ merchant }) => {
      try {
        await api.put(
          `/companies/${user.empresa_id}/integrations/${credentialId}`,
          {
            key: merchant,
          },
        );

        setMerchantId(merchant);
      } catch (err) {
        addToast({
          title: 'Erro ao finalizar integração',
        });
      }
    },
    [user.empresa_id, credentialId, addToast],
  );

  const handleDisableIfood = useCallback(async () => {
    try {
      await api.delete(
        `/companies/${user.empresa_id}/integrations/${credentialId}`,
      );

      setCredentialId(undefined);
      getUserCodeLink();
    } catch (err) {
      addToast({
        title: 'Erro ao tentar desabilitar o iFood',
      });
    }
  }, [user.empresa_id, credentialId, addToast, getUserCodeLink]);

  return (
    <S.Container>
      <h1>iFood</h1>

      <p className="description">
        Ao habilitar este serviço, você poderá controlar os pedidos feitos no
        iFood.
      </p>

      {userCodeLink && (
        <>
          <Button
            component={Link}
            href={userCodeLink}
            target="_blank"
            style={{
              backgroundColor: '#329BFC',
              color: '#ffffff',
              maxWidth: 300,
              marginBottom: 40,
            }}
          >
            Habilitar o iFood
          </Button>
          <Form onSubmit={handleSubmit} initialData={{ clientId: null }}>
            <Grid item lg={4} md={6} xs={12}>
              <p className="description">
                Após habilitar o iFood, cole aqui o código mostrado no portal
              </p>
              <span>Código:</span>

              <Input
                placeholder="Digite o código mostrado no portal do iFood"
                name="code"
              />
            </Grid>

            <Grid item lg={4} md={6} xs={12}>
              <ButtonStyled type="submit">Continuar</ButtonStyled>
            </Grid>
          </Form>
        </>
      )}
      {credentialId && !merchantId && (
        <Form onSubmit={handleFinish} initialData={{ merchant: null }}>
          <Grid item lg={4} md={6} xs={12}>
            <p className="description">
              Para finalizar, selecione a loja que você deseja integrar
            </p>
            <span>Loja:</span>

            <Select
              options={merchants}
              placeholder="Selecione uma loja"
              name="merchant"
            />
          </Grid>

          <Grid item lg={4} md={6} xs={12}>
            <ButtonStyled type="submit">Finalizar</ButtonStyled>
          </Grid>
        </Form>
      )}
      {merchantId && credentialId && (
        <Button
          style={{
            backgroundColor: '#ff0000',
            color: '#ffffff',
            maxWidth: 300,
            marginBottom: 40,
          }}
          onClick={handleDisableIfood}
        >
          Desabilitar o iFood
        </Button>
      )}
    </S.Container>
  );
};

export default IFood;
